import React from 'react';

const Earnings = () => {
    return(
        <h1>Hello World</h1>
    )
}

export default Earnings;